// extracted by mini-css-extract-plugin
export var highlightFade = "_3f-4";
export var highlighted = "_3f-3";
export var table = "_3f-1";
export var tableContainer = "_3f-0";
export var totalsRow = "_3f-2";